module.exports = __webpack_public_path__ + "img/techlend.c16524be.svg";